import classNames from 'classnames';
import React, {useCallback} from 'react';

import {StarEmptyIcon, StarFillIcon, StarHalfIcon} from '../../../resources/Icons';
import Row from '../../common/Row';

type Props = {
  className?: string;
  rating: number;
  showAverage?: boolean;
  count?: number;
};

const StarRatings = (props: Props) => {
  const {rating, showAverage, count, className} = props;

  const renderStars = useCallback(() => {
    let stars = [];
    for (let i = 0; i < 5; i++) {
      if (i + 1 <= rating) {
        stars.push(<StarFillIcon key={`star_${i}`} />);
      } else if (i + 1 === Math.ceil(rating) && rating % 1 >= 0.5) {
        stars.push(<StarHalfIcon key={`star_${i}`} />);
      } else {
        stars.push(<StarEmptyIcon key={`star_${i}`} />);
      }
    }
    return stars;
  }, [rating]);

  return (
    <Row className={classNames('text-xs text-gray-200 space-x-2', className)}>
      {showAverage && <div>{rating.toFixed(1)}</div>}
      <Row className={'gap-1'} role={'img'} aria-label={`${rating} out of 5 stars`}>
        {renderStars()}
      </Row>
      {count !== undefined && <div>({Math.floor(count)})</div>}
    </Row>
  );
};

export default StarRatings;
